import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@v/Home.vue";
import store from "../store";
import Indicator from "vue-indicator";

Vue.use(VueRouter);

function lazyLoad(promise) {
  return new Promise((resolve) => {
    Indicator.open("努力加载中...");
    promise.then(() => {
      resolve(promise);
      Indicator.close();
    });
  });
}

const routes = [
  {
    path: "/",
    name: "home",
    meta: {
      pageAnimationDisable: true,
    },
    component: Home,
  },
  {
    path: "/my",
    name: "my",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/My.vue")),
  },
  {
    path: "/knowVirtualCurrency",
    name: "vc",
    component: () => lazyLoad(import("@v/pay/VirtualCurrency.vue")),
  },
  {
    path: "/jump",
    name: "jump",
    component: () => lazyLoad(import("@v/jump/Index.vue")),
  },
  {
    path: "/maintenance",
    name: "maintenance",
    component: () => lazyLoad(import("@v/warning/Maintenance.vue")),
  },
  {
    path: "/403",
    name: "403",
    component: () => lazyLoad(import("@v/warning/403.vue")),
  },
  {
    path: "/pay/success",
    name: "rechargeSuccess",
    component: () => lazyLoad(import("@v/pay/Success.vue")),
  },
  {
    path: "/login",
    name: "login",
    component: () => lazyLoad(import("@v/Login.vue")),
  },
  {
    path: "/pages/register/register",
    name: "register",
    component: () => lazyLoad(import("@v/Register.vue")),
  },
  {
    path: "/im",
    name: "IM",
    component: () => lazyLoad(import("@v/IM.vue")),
  },
  {
    path: "/Search",
    name: "Search",
    component: () => lazyLoad(import("@v/Search.vue")),
  },
  {
    path: "/Refresh",
    name: "Refresh",
    component: () => lazyLoad(import("@v/Refresh.vue")),
  },
  {
    path: "/provision",
    name: "provision",
    component: () => lazyLoad(import("@v/Provision.vue")),
  },
  {
    path: "/lotteryhall",
    name: "lotteryhall",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/LotteryHall.vue")),
  },
  {
    path: "/drawrecords",
    name: "drawrecords",
    component: () => lazyLoad(import("@v/lottery/DrawRecords.vue")),
  },
  {
    path: "/Openlobby",
    name: "openlobby",
    component: () => lazyLoad(import("@v/lottery/Openlobby.vue")),
  },
  {
    path: "/lotterycredit",
    name: "lotterycredit",
    component: () => lazyLoad(import("@v/LotteryCredit.vue")),
  },
  {
    path: "/lotterypurchase",
    name: "lotterypurchase",
    component: () => lazyLoad(import("@v/LotteryPurchase.vue")),
  },
  {
    path: "/lotteryTransition",
    name: "lotteryTransition",
    component: () => lazyLoad(import("@v/lotteryTransition.vue")),
  },
  {
    path: "/lotteryChase",
    name: "lotteryChase",
    component: () => lazyLoad(import("@v/LotteryChase.vue")),
  },
  {
    path: "/lotteryConfirm",
    name: "lotteryConfirm",
    component: () => lazyLoad(import("@v/LotteryConfirm.vue")),
  },
  {
    path: "/lottery/trend",
    name: "trend",
    component: () => lazyLoad(import("@v/trend/Trend.vue")),
  },
  {
    path: "/guide/credit/k3",
    name: "creditk3",
    component: () => lazyLoad(import("@v/guide/credit/K3.vue")),
  },
  {
    path: "/guide/credit/zhishu",
    name: "creditzhishu",
    component: () => lazyLoad(import("@v/guide/credit/ZHISHU.vue")),
  },
  {
    path: "/guide/credit/lhc",
    name: "creditlhc",
    component: () => lazyLoad(import("@v/guide/credit/LHC.vue")),
  },
  {
    path: "/guide/credit/lsc",
    name: "creditlsc",
    component: () => lazyLoad(import("@v/guide/credit/LSC.vue")),
  },
  {
    path: "/guide/credit/pcdd",
    name: "creditpcdd",
    component: () => lazyLoad(import("@v/guide/credit/PCDD.vue")),
  },
  {
    path: "/guide/credit/pl3",
    name: "creditpl3",
    component: () => lazyLoad(import("@v/guide/credit/PL3.vue")),
  },
  {
    path: "/guide/credit/3d",
    name: "credit3d",
    component: () => lazyLoad(import("@v/guide/credit/3D.vue")),
  },
  {
    path: "/guide/credit/pk10",
    name: "creditpk10",
    component: () => lazyLoad(import("@v/guide/credit/PK10.vue")),
  },
  {
    path: "/guide/credit/ssc",
    name: "creditssc",
    component: () => lazyLoad(import("@v/guide/credit/SSC.vue")),
  },
  {
    path: "/guide/official/11x5",
    name: "official11x5",
    component: () => lazyLoad(import("@v/guide/official/11X5.vue")),
  },
  {
    path: "/guide/official/k3",
    name: "officialk3",
    component: () => lazyLoad(import("@v/guide/official/K3.vue")),
  },
  {
    path: "/guide/official/zhishu",
    name: "officialzhishu",
    component: () => lazyLoad(import("@v/guide/official/ZHISHU.vue")),
  },
  {
    path: "/guide/official/lhc",
    name: "officiallhc",
    component: () => lazyLoad(import("@v/guide/official/LHC.vue")),
  },
  {
    path: "/guide/official/lsc",
    name: "officiallsc",
    component: () => lazyLoad(import("@v/guide/official/LSC.vue")),
  },
  {
    path: "/guide/official/pcdd",
    name: "officialpcdd",
    component: () => lazyLoad(import("@v/guide/official/PCDD.vue")),
  },
  {
    path: "/guide/official/pl3",
    name: "officialpl3",
    component: () => lazyLoad(import("@v/guide/official/PL3.vue")),
  },
  {
    path: "/guide/official/3d",
    name: "official3d",
    component: () => lazyLoad(import("@v/guide/official/3D.vue")),
  },
  {
    path: "/guide/official/pk10",
    name: "officialpk10",
    component: () => lazyLoad(import("@v/guide/official/PK10.vue")),
  },
  {
    path: "/guide/official/ssc",
    name: "officialssc",
    component: () => lazyLoad(import("@v/guide/official/SSC.vue")),
  },
  {
    path: "/guide/official/ssq",
    name: "officialssq",
    component: () => lazyLoad(import("@v/guide/official/SSQ.vue")),
  },
  {
    path: "/guide/official/dlt",
    name: "officialdlt",
    component: () => lazyLoad(import("@v/guide/official/DLT.vue")),
  },
  {
    path: "/elesports",
    redirect: { path: '/', query: { key: 'elegameSports' } }
  },
  {
    path: "/realman",
    redirect: { path: '/', query: { key: 'realman' } }
  },
  {
    path: "/sports",
    redirect: { path: '/', query: { key: 'sports' } }
  },
  {
    path: "/chessHall",
    name: "chessHall",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/chessHall.vue")),
  },
  {
    path: "/fans",
    name: "fans",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum/fans.vue")),
  },
  {
    path: "/forum",
    name: "forum",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum/ForumPage.vue")),
  }, {
    path: "/forumEdit",
    name: "forumEdit",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum/ForumEdit.vue")),
  },
  {
    path: "/forumInfo",
    name: "forumInfo",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum/ForumContent.vue")),
  },
  {
    path: "/fans3",
    name: "fans3",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum3/fans.vue")),
  },
  {
    path: "/forum3",
    name: "forum3",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum3/ForumPage.vue")),
  }, {
    path: "/forum3Edit",
    name: "forum3Edit",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum3/ForumEdit.vue")),
  },
  {
    path: "/forum3Info",
    name: "forum3Info",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/forum3/ForumContent.vue")),
  },
  {
    path: "/gameTab",
    name: "gameTab",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/gameTab.vue")),
  },
  {
    path: "/egameHall",
    name: "egameHall",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/egameHall.vue")),
  },
  {
    path: "/fishHall",
    name: "fishHall",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/fishHall.vue")),
  },
  {
    path: "/xuanfei",
    name: "xuanfei",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/xuanfei.vue")),
  },
  {
    path: "/dating",
    name: "dating",
    meta: {
      pageAnimationDisable: true,
    },
    component: () => lazyLoad(import("@v/dating.vue")),
  },
  // game
  {
    path: "/GameLoadingPage",
    name: "GameLoadingPage",
    component: () => lazyLoad(import("@v/game/GameLoadingPage.vue")),
  },
  // personal
  {
    path: "/usersetting",
    name: "usersetting",
    component: () => lazyLoad(import("@v/personal/UserSetting.vue")),
  },
  {
    path: "/personalinfomation",
    name: "personalinfomation",
    component: () => lazyLoad(import("@v/personal/PersonalInfomation.vue")),
  },
  {
    path: "/about",
    name: "about",
    component: () => lazyLoad(import("@v/personal/About.vue")),
  },
  {
    path: "/updateinfo/:key",
    name: "updateinfo",
    component: () => lazyLoad(import("@v/personal/updateInfo.vue")),
  },
  // record
  {
    path: "/bettingplatform",
    name: "bettingplatform",
    component: () => lazyLoad(import("@v/record/BettingPlatform.vue")),
  },
  {
    path: "/transfertomember",
    name: "transfertomember",
    component: () => lazyLoad(import("@v/pay/Transfertomember.vue")),
  },
  {
    path: "/lotteryorderhistory",
    name: "lotteryorderhistory",
    component: () => lazyLoad(import("@v/record/LotteryOrderHistory.vue")),
  },
  {
    path: "/lotteryorderdetail",
    name: "lotteryorderdetail",
    component: () => lazyLoad(import("@v/record/LotteryOrderDetail.vue")),
  },
  {
    path: "/lotteryorderchasedetail",
    name: "lotteryorderchasedetail",
    component: () => lazyLoad(import("@v/record/LotteryOrderChaseDetail.vue")),
  },
  {
    path: "/lotteryorderdetailcontent",
    name: "lotteryorderdetailcontent",
    component: () => lazyLoad(import("@v/record/LotteryOrderDetailContent.vue")),
  },
  {
    path: "/LotteryOrderFilter",
    name: "LotteryOrderFilter",
    component: () => lazyLoad(import("@v/record/LotteryOrderFilter.vue")),
  },
  {
    path: "/expenditurerecord",
    name: "expenditurerecord",
    component: () => lazyLoad(import("@v/record/ExpenditureRecord.vue")),
  },
  {
    path: "/GamePlayRecordFilter",
    name: "GamePlayRecordFilter",
    component: () => lazyLoad(import("@v/record/GamePlayRecordFilter.vue")),
  },
  {
    path: "/BillChangeRecord",
    name: "BillChangeRecord",
    component: () => lazyLoad(import("@v/record/BillChangeRecord.vue")),
  },
  {
    path: "/BillChangeRecordDetail",
    name: "BillChangeRecordDetail",
    component: () => lazyLoad(import("@v/record/BillChangeRecordDetail.vue")),
  },
  {
    path: "/RechargeWithdrawalRecord",
    name: "RechargeWithdrawalRecord",
    component: () => lazyLoad(import("@v/record/RechargeWithdrawalRecord.vue")),
  },
  {
    path: "/PayOrWithdrawal",
    name: "PayOrWithdrawal",
    component: () => lazyLoad(import("@v/record/PayOrWithdrawal.vue")),
  },
  {
    path: "/Walletdetails",
    name: "Walletdetails",
    component: () => lazyLoad(import("@v/record/Walletdetails.vue")),
  },
  {
    path: "/WalletProgress",
    name: "WalletProgress",
    component: () => lazyLoad(import("@v/record/WalletProgress.vue")),
  },
  {
    path: "/transferRecord",
    name: "transferRecord",
    component: () => lazyLoad(import("@v/record/transferRecord.vue")),
  },
  {
    path: "/transferRecordDetail",
    name: "transferRecordDetail",
    component: () => lazyLoad(import("@v/record/transferRecordDetail.vue")),
  },
  {
    path: "/PersonalOrTeamReport",
    name: "PersonalOrTeamReport",
    component: () => lazyLoad(import("@v/record/PersonalOrTeamReport.vue")),
  },
  {
    path: "/activityRoom",
    name: "activityRoom",
    component: () => lazyLoad(import("@v/record/activityRoom.vue")),
  },
  {
    path: "/activityRoomDetails",
    name: "activityRoomDetails",
    component: () => lazyLoad(import("@v/record/activityRoomDetails.vue")),
  },

  // pay
  {
    path: "/Recharge",
    name: "Recharge",
    component: () => lazyLoad(import("@v/pay/Recharge.vue")),
  },
  {
    path: "/RechargeNei",
    name: "RechargeNei",
    component: () => lazyLoad(import("@v/pay/RechargeNei.vue")),
  },
  {
    path: "/Recharge/PayQrcode",
    name: "PayQrcode",
    component: () => lazyLoad(import("@v/pay/PayQrcode.vue")),
  },
  {
    path: "/Recharge/PayQrcodeFinshed",
    name: "PayQrcodeFinshed",
    component: () => lazyLoad(import("@v/pay/PayQrcodeFinshed.vue")),
  },
  {
    path: "/Recharge/PayOnlineWay",
    name: "PayOnlineWay",
    component: () => lazyLoad(import("@v/pay/PayOnlineWay.vue")),
  },
  {
    path: "/Recharge/PayVcWay",
    name: "PayVcWay",
    component: () => lazyLoad(import("@v/pay/PayVcWay.vue")),
  },
  {
    path: "/Recharge/PayBankInput",
    name: "PayBankInput",
    component: () => lazyLoad(import("@v/pay/PayBankInput.vue")),
  },
  {
    path: "/Recharge/PayBankConfirm",
    name: "PayBankConfirm",
    component: () => lazyLoad(import("@v/pay/PayBankConfirm.vue")),
  },
  {
    path: "/Transfer",
    name: "Transfer",
    component: () => lazyLoad(import("@v/pay/Transfer.vue")),
  },
  {
    path: "/TransferDsf",
    name: "TransferDsf",
    component: () => lazyLoad(import("@v/pay/TransferDsf.vue")),
  },
  {
    path: "/Wallet",
    name: "Wallet",
    component: () => lazyLoad(import("@v/pay/Wallet.vue")),
  },
  {
    path: "/Withdrawal",
    name: "Withdrawal",
    component: () => lazyLoad(import("@v/pay/Withdrawal.vue")),
  },
  {
    path: "/Recharge/PayOnlineGuadan",
    name: "PayOnlineGuadan",
    component: () => lazyLoad(import("@v/pay/payOnlineGuadan.vue")),
  },
  {
    path: "/Recharge/PayOnlineGuadanOrder",
    name: "PayOnlineGuadanOrder",
    component: () => lazyLoad(import("@v/pay/PayOnlineGuadanOrder.vue")),
  },
  {
    path: "/Recharge/PayOnlineGuadanOrderInfo",
    name: "PayOnlineGuadanOrderInfo",
    component: () => lazyLoad(import("@v/pay/PayOnlineGuadanOrderInfo.vue")),
  },

  {
    path: "/Recharge/PayOnlineGuadanSellInfo",
    name: "PayOnlineGuadanSellInfo",
    component: () => lazyLoad(import("@v/pay/PayOnlineGuadanSellInfo.vue")),
  },

  {
    path: "/Recharge/PayOnlineGuadanWithdrawal",
    name: "payOnlineGuadanWithdrawal",
    component: () => lazyLoad(import("@v/pay/payOnlineGuadanWithdrawal.vue")),
  },
  {
    path: "/Recharge/PayOnlineGuadanLogList",
    name: "payOnlineGuadanLogList",
    component: () => lazyLoad(import("@v/pay/payOnlineGuadanLogList.vue")),
  },
  {
    path: "/Recharge/PayOnlineGuadanPreImg",
    name: "payOnlineGuadanPreImg",
    component: () => lazyLoad(import("@v/pay/payOnlineGuadanPreImg.vue")),
  },


  // activities
  {
    path: "/IntegralExchange",
    name: "IntegralExchange",
    component: () => lazyLoad(import("@v/activities/IntegralExchange.vue")),
  },
  {
    path: "/IntegralRecord",
    name: "IntegralRecord",
    component: () => lazyLoad(import("@v/activities/IntegralRecord.vue")),
  },
  {
    path: "/IntegralRecordFilter",
    name: "IntegralRecordFilter",
    component: () => lazyLoad(import("@v/activities/IntegralRecordFilter.vue")),
  },
  {
    path: "/Preferential",
    name: "Preferential",
    component: () => lazyLoad(import("@v/activities/Preferential.vue")),
  },
  {
    path: "/PreferentialDetail",
    name: "PreferentialDetail",
    component: () => lazyLoad(import("@v/activities/PreferentialDetail.vue")),
  },
  {
    path: "/Sign",
    name: "Sign",
    component: () => lazyLoad(import("@v/activities/Sign.vue")),
  },
  {
    path: "/HeroList",
    name: "HeroList",
    component: () => lazyLoad(import("@v/activities/HeroList.vue")),
  },
  {
    path: "/Redbag",
    name: "Redbag",
    component: () => lazyLoad(import("@v/activities/Redbag.vue")),
  },
  // message
  {
    path: "/message/MessageCenter",
    name: "MessageCenter",
    component: () => lazyLoad(import("@v/message/MessageCenter.vue")),
  },
  {
    path: "/message/MailList",
    name: "MailList",
    component: () => lazyLoad(import("@v/message/MailList.vue")),
  },
  {
    path: "/message/NoticeList",
    name: "NoticeList",
    component: () => lazyLoad(import("@v/message/NoticeList.vue")),
  },
  // proxy
  {
    path: "/OpeningAccountCenter",
    name: "OpeningAccountCenter",
    component: () => lazyLoad(import("@v/proxy/OpeningAccountCenter.vue")),
  },
  {
    path: "/ProxyCommission",
    name: "ProxyCommission",
    component: () => lazyLoad(import("@v/proxy/ProxyCommission.vue")),
  },
  {
    path: "/UserManage",
    name: "UserManage",
    component: () => lazyLoad(import("@v/proxy/UserManage.vue")),
  },
  {
    path: "/ProxyRpSet",
    name: "ProxyRpSet",
    component: () => lazyLoad(import("@v/proxy/ProxyRpSet.vue")),
  },
  {
    path: "/UserDetail",
    name: "UserDetail",
    component: () => lazyLoad(import("@v/proxy/UserDetail.vue")),
  },
  // safe
  {
    path: "/SafeCenter",
    name: "SafeCenter",
    component: () => lazyLoad(import("@v/safe/SafeCenter.vue")),
  },
  {
    path: "/SetTraderPassword",
    name: "SetTraderPassword",
    component: () => lazyLoad(import("@v/safe/SetTraderPassword.vue")),
  },
  {
    path: "/UpdateLoginPassword",
    name: "UpdateLoginPassword",
    component: () => lazyLoad(import("@v/safe/UpdateLoginPassword.vue")),
  },
  {
    path: "/UpdateTraderPassword",
    name: "UpdateTraderPassword",
    component: () => lazyLoad(import("@v/safe/UpdateTraderPassword.vue")),
  },
  // bankcard
  {
    path: "/BankcardManage",
    name: "BankcardManage",
    component: () => lazyLoad(import("@v/bankcard/BankcardManage.vue")),
  },
  {
    path: "/BankCardManagement",
    name: "BankCardManagement",
    component: () => lazyLoad(import("@v/bankcard/BankCardManagement.vue")),
  },
  {
    path: "/Bindcard",
    name: "Bindcard",
    component: () => lazyLoad(import("@v/bankcard/Bindcard.vue")),
  },
  {
    path: "/Financial",
    name: "Financial",
    component: () => lazyLoad(import("@v/financial/Financial.vue")),
  },
  {
    path: "/Yeb",
    name: "Yeb",
    component: () => lazyLoad(import("@v/yeb/Yeb.vue")),
  },
  {
    path: "/YebRecord",
    name: "YebRecord",
    component: () => lazyLoad(import("@v/yeb/YebRecord.vue")),
  },
  {
    path: "/YebCheckRecord",
    name: "YebCheckRecord",
    component: () => lazyLoad(import("@v/yeb/YebCheckRecord.vue")),
  },
  {
    path: "/YebTransfer",
    name: "YebTransfer",
    component: () => lazyLoad(import("@v/yeb/YebTransfer.vue")),
  },
  {
    path: "/YebTransferSuccess",
    name: "YebTransferSuccess",
    component: () => lazyLoad(import("@v/yeb/YebTransferSuccess.vue")),
  },
  {
    path: "/YebGuide",
    name: "YebGuide",
    component: () => lazyLoad(import("@v/yeb/YebGuide.vue")),
  },
  {
    path: "/balanceIncome",
    name: "BalanceIncome",
    component: () => lazyLoad(import("@v/balanceIncome/BalanceIncome.vue")),
  },
  {
    path: "/balanceIncomeIntroduce",
    name: "BalanceIncomeIntroduce",
    component: () => lazyLoad(import("@v/balanceIncome/BalanceIncomeIntroduce.vue")),
  },
  {
    path: "/balanceIncomeRecord",
    name: "BalanceIncomeRecord",
    component: () => lazyLoad(import("@v/balanceIncome/BalanceIncomeRecord.vue")),
  },
  //威尼斯
  {
    path: "/dsfGameList",
    name: "dsfGameList",
    component: () => lazyLoad(import("@v/game/dsfGameList.vue")),
  },
  {
    path: "/fishGameList",
    name: "fishGameList",
    component: () => lazyLoad(import("@v/game/fishGameList.vue")),
  },
  {
    path: "/guide/credit/11x5",
    name: "credit11x5",
    component: () => lazyLoad(import("@v/guide/credit/11X5.vue")),
  },
  {
    path: "/guide/credit/ssq",
    name: "creditssq",
    component: () => lazyLoad(import("@v/guide/credit/SSQ.vue")),
  },
  {
    path: "/guide/credit/dlt",
    name: "creditdlt",
    component: () => lazyLoad(import("@v/guide/credit/DLT.vue")),
  },
  //佳丽
  {
    path: "/jialiDetails",
    name: "jialiDetails",
    component: () => lazyLoad(import("@v/jiali/jialiDetails.vue")),
  },
  //usdt
  {
    path: "/course",
    name: "course",
    component: () => lazyLoad(import("@v/pay/course.vue")),
  },
  //gopay
  {
    path: "/gopay",
    name: "gopay",
    component: () => lazyLoad(import("@v/pay/gopay.vue")),
  },
  //gopay
  {
    path: "/gopayCourse",
    name: "gopayCourse",
    component: () => lazyLoad(import("@v/pay/gopayCourse.vue")),
  },
  {
    path: "/okpay",
    name: "okpay",
    component: () => lazyLoad(import("@v/pay/okpay.vue")),
  },
  {
    path: "/okpayCourse",
    name: "okpayCourse",
    component: () => lazyLoad(import("@v/pay/okpayCourse.vue")),
  },
  {
    path: "/topay",
    name: "topay",
    component: () => lazyLoad(import("@v/pay/topay.vue")),
  },
  {
    path: "/topayCourse",
    name: "topayCourse",
    component: () => lazyLoad(import("@v/pay/topayCourse.vue")),
  },
  {
    path: "/discovery",
    name: "Discovery",
    component: () => lazyLoad(import("@v/Discovery.vue")),
  },
  {
    path: "/pictureWarehouse",
    name: "PictureWarehouse",
    component: () => lazyLoad(import("@v/pictureWarehouse/PictureWarehouse.vue")),
  },
  {
    path: "/PictureWarehouseDetail",
    name: "PictureWarehouseDetail",
    component: () => lazyLoad(import("@v/pictureWarehouse/PictureWarehouseDetail.vue")),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

//需要登录才能进入的路由
const needLoginRoute = [
  "/lotterypurchase",
  "/Wallet",
  "/Walletdetails",
  "/WalletProgress",
  "/Recharge",
  "RechargeNei",
  "/Recharge/PayBankInput",
  "/Recharge/PayBankConfirm",
  "/Recharge/PayQrcode",
  "/Recharge/PayQrcodeFinshed",
  "/Recharge/PayOnlineWay",
  "/Recharge/PayVcWay",
  "/Recharge/PayOnlineGuadan",
  "/Recharge/PayOnlineGuadanOrder",
  "/Recharge/PayOnlineGuadanOrderInfo",
  "/Recharge/PayOnlineGuadanSellInfo",
  "/Recharge/PayOnlineGuadanWithdrawal",
  "/Recharge/PayOnlineGuadanLogList",
  "/Recharge/PayOnlineGuadanPreImg",
  "/Transfer",
  "/TransferDsf",
  "/Withdrawal",
  "/PayOrWithdrawal",
  "/RechargeWithdrawalRecord",
  "/lotteryorderhistory",
  "/BillChangeRecord",
  "/BillChangeRecordDetail",
  "/PersonalOrTeamReport",
  "/UserManage",
  "/OpeningAccountCenter",
  "/ProxyCommission",
  "/SafeCenter",
  "/usersetting",
  "/bettingplatform",
  "/lotterycredit",
  "/Redbag",
  "/Sign",
  "/IntegralRecord",
  "/IntegralRecordFilter",
  "/IntegralExchange",
  "/personalinfomation",
  "/ProxyCommission",
  "/im",
  "/Yeb",
  "/Transfertomember"
];

//需要正常账号才可以进入的路由，试玩账号不允许进入的路由
const needAuthRoute = [
  "/Wallet",
  "/Walletdetails",
  "/WalletProgress",
  "/Recharge",
  "RechargeNei",
  "/Recharge/PayBankInput",
  "/Recharge/PayBankConfirm",
  "/Recharge/PayQrcode",
  "/Recharge/PayQrcodeFinshed",
  "/Recharge/PayOnlineWay",
  "/Recharge/PayVcWay",
  "/Recharge/PayOnlineGuadan",
  "/Recharge/PayOnlineGuadanOrder",
  "/Recharge/PayOnlineGuadanOrderInfo",
  "/Recharge/PayOnlineGuadanSellInfo",
  "/Recharge/PayOnlineGuadanWithdrawal",
  "/Recharge/PayOnlineGuadanLogList",
  "/Recharge/PayOnlineGuadanPreImg",
  "/Transfer",
  "/TransferDsf",
  "/Withdrawal",
  "/PayOrWithdrawal",
  "/RechargeWithdrawalRecord",
  "/BillChangeRecord",
  "/BillChangeRecordDetail",
  "/PersonalOrTeamReport",
  "/IntegralExchange",
  "/SafeCenter",
  "/Sign",
  "/Redbag",
  "/IntegralRecord",
  "/IntegralRecordFilter",
  "/OpeningAccountCenter",
  "/UserManage",
  "/personalinfomation",
  "/ProxyCommission",
  "/im",

];

//推广账号无法进入的路由
const needTgRoute = ["/Transfer", "/TransferDsf"];
//需要清空投注记录的查询参数的路由
const needClearQuery = ["/bettingplatform", "/lotterypurchase", "/lotterycredit"];

router.beforeResolve((to, from, next) => {

  // 是否有注册邀请码参数
  const { promoteCode } = to.query
  if (!!promoteCode) {
    const expire = new Date().getTime()
    localStorage.setItem('promoteCode', promoteCode) // 邀请码
    localStorage.setItem('codeExpireTime', expire) // 存储过期时间
  }

  const TOKEN = store.state.user.token;
  //获取登录页配置 "toast" | "jumpLogin"
  let loginTipsMode = 'toast'
  try {
    loginTipsMode = store.state.app.appConfig.common_config.configValue.loginTipsMode || 'toast'
  } catch (e) {
    loginTipsMode = 'toast'
  }
  loginTipsMode = loginTipsMode == undefined ? 'toast' : loginTipsMode

  console.log(TOKEN,)
  const USERINFO = store.state.user.userInfo;
  if (needLoginRoute.includes(to.path) && !TOKEN) {
    if (loginTipsMode == 'jumpLogin') {
      next('/login')
    } else {
      router.app.$toast("请登录后操作");
      next(from.path);
    }
    return;
  } else if (USERINFO.memberType == 3 && needAuthRoute.includes(to.path)) {
    router.app.$toast("试玩账号无此权限");
    next(from.path);
    return;
  } else if (USERINFO.memberType == 4 && needTgRoute.includes(to.path)) {
    router.app.$toast("推广账号无此权限");
    next(from.path);
    return;
  } else if (needClearQuery.includes(from.path)) {
    store.commit("user/clearBetRecordQuery");
    next();
    return;
  } else {
    store.commit('user/setShowOffLineAlert', false)
    next();
    return;
  }
});

export default router;
